import React, { useState, useEffect } from 'react';
import { Table, Pagination, Form, Tabs, Tab } from "react-bootstrap";
import { getInvoiceByUser, getInvoiceCSHPByUser } from "../../components/Service/Oder";
import { useNavigate } from 'react-router-dom';
import useLanguage from '../../Hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import LoadingSpinner from '../../css/Loading';
const Invoice = () => {
    const navigate = useNavigate();
    const [invoice, setInvoice] = useState([]);
    const [cshpInvoice, setCshpInvoice] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [activeTab, setActiveTab] = useState('cssp');
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [loading, setLoading] = useState(true);

    const API_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchData = async () => {
            const data = await getInvoiceByUser();
            setInvoice(data.invoice?.sort((a, b) => b.id - a.id) || []);
            setLoading(false);
        };
        fetchData();

        // const fetchCshpData = async () => {
        //     const data = await getInvoiceCSHPByUser();
        //     setCshpInvoice(data.invoice?.sort((a, b) => b.id - a.id) || []);
        // };
        // fetchCshpData();
    }, [selectedMonth, selectedYear]);


    const filteredCshpInvoice = cshpInvoice.filter(muc => {
        const invoiceDate = new Date(muc.created_at);
        const invoiceMonth = invoiceDate.getMonth() + 1; // Month is 0-indexed
        const invoiceYear = invoiceDate.getFullYear();
        return invoiceMonth === selectedMonth && invoiceYear === selectedYear;
    });

    const currentData = activeTab === 'cssp' ? invoice : cshpInvoice;
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = currentData.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(currentData.length / rowsPerPage);

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setCurrentPage(1);
    };
    const handleMonthChange = (event) => {
        setSelectedMonth(parseInt(event.target.value));
        setCurrentPage(1);
        // fetchFilteredInvoices();
    };

    const handleYearChange = (event) => {
        setSelectedYear(parseInt(event.target.value));
        setCurrentPage(1);
        // fetchFilteredInvoices();
    };

    useEffect(() => {
        const fetchFilteredInvoices = async () => {
            const response = await fetch(`${API_URL}/api/v1/filter-invoice-by-item`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${Cookies.get("Token")}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    month: selectedMonth,
                    year: selectedYear
                })
            });

            const data = await response.json();

            if (response.ok) {
                setCshpInvoice((data.invoices || []).reverse());
            } else {
                setCshpInvoice([]);
            }
            setLoading(false)
        };

        fetchFilteredInvoices();
    }, [selectedMonth, selectedYear]);


    const handlePaymentClick = (row) => {
        navigate(`/invoice-detail/${row.id}`);
    }

    const handleViewDetails = (invoiceId) => navigate(`/invoice-detail/${invoiceId}`);
    const handleViewDetailsCSHP = (invoiceId) => {
        navigate(`/cshp/invoice-detail/${invoiceId}?month=${selectedMonth}&year=${selectedYear}`);
    };
    useLanguage();

    const { t } = useTranslation();
    const statusColors = { 0: "#FFC107", 1: "#28A745", 2: "#6C757D", 3: "#DC3545", 4: "#17A2B8", 5: "#FD7E14", 6: "#FF5733" };
    const statusLabels = { 0: t("Unpaid"), 1: t("Paid"), 2: t("Draft"), 3: t("Cancelled"), 4: t("Refunded"), 5: t("Collections"), 6: t("Overdue") };
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    if (loading) {
        return (
            <LoadingSpinner></LoadingSpinner>
        );
    }
    return (
        <div className="px-4 py-4">
            <Tabs activeKey={activeTab} onSelect={(key) => { setActiveTab(key); setCurrentPage(1); }} id="invoice-tabs">

                <Tab eventKey="cssp" title="CSSP">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <span>{invoice.length} {t("Records Found")}, {t("Showing")} {indexOfFirstRow + 1} {t("to")} {Math.min(indexOfLastRow, invoice.length)}</span>
                        <Form.Select value={rowsPerPage} onChange={handleRowsPerPageChange} style={{ width: '150px' }}>
                            {[10, 25, 50, 100].map(value => <option key={value} value={value}>{value}</option>)}
                        </Form.Select>
                    </div>
                    <Table bordered hover>
                        <thead>
                            <tr>
                                <th>{t("Invoice number")}</th><th>{t("Creation date")}</th><th>{t("Payment date")}</th><th>{t("End date")}</th><th>{t("Total Amount")}</th><th>{t("Status")}</th> <th>{t("Action")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentRows.map((muc, index) => (
                                <tr key={index}>
                                    <td onClick={() => handleViewDetails(muc.id)} style={{ color: "#0069ff", cursor: "pointer" }}>#{muc?.invoice_number}</td>
                                    <td>{new Date(muc.created_at).toLocaleDateString('vi-VN')}</td>
                                    <td>{muc.paid_date ? new Date(muc.paid_date).toLocaleDateString('vi-VN') : '-'}</td>
                                    <td>{muc.due_date ? new Date(muc.due_date).toLocaleDateString('vi-VN') : '-'}</td>
                                    <td>{new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(muc?.total)}</td>
                                    <td>
                                        <span
                                            style={{
                                                cursor: muc.status === 0 ? "pointer" : "default",
                                                backgroundColor: statusColors[muc.status] || "#6C757D",
                                                color: "#fff",
                                                padding: "3px 10px",
                                                borderRadius: "10px",
                                                display: "inline-block",
                                                fontSize: "12px",
                                                fontWeight: "bold"
                                            }}
                                        >
                                            {statusLabels[muc.status] || "Không xác định"}
                                        </span>
                                    </td>
                                    <td>{muc.status === 0 && <a onClick={() => handlePaymentClick(muc)} style={{ color: "#0069ff", cursor: "pointer" }}>{t("Payment")}</a>}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <Pagination className="justify-content-center">
                        {[...Array(totalPages)].map((_, i) => (
                            <Pagination.Item key={i} active={i + 1 === currentPage} onClick={() => handlePageChange(i + 1)}>
                                {i + 1}
                            </Pagination.Item>
                        ))}
                    </Pagination>
                </Tab>

                <Tab eventKey="cshp" title="CSHP">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="d-flex align-items-center">
                            <label className="me-2 fw-bold">{t("Invoices by month")}</label>
                            <Form.Select value={selectedMonth} onChange={handleMonthChange} style={{ width: '150px' }}>
                                {Array.from({ length: 12 }, (_, i) => {
                                    const month = i + 1;
                                    return <option key={month} value={month}>{t(months[month - 1])}</option>;
                                })}
                            </Form.Select>
                            <label className="ms-3 me-2 fw-bold">{t("Year")}</label>
                            <Form.Select value={selectedYear} onChange={handleYearChange} style={{ width: '150px' }}>
                                {Array.from({ length: 5 }, (_, i) => {
                                    const yearOption = new Date().getFullYear() - i;
                                    return <option key={yearOption} value={yearOption}>{yearOption}</option>;
                                })}
                            </Form.Select>
                        </div>

                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <span style={{ marginRight: "10px" }}>{cshpInvoice.length} {t("Records Found")}, {t("Showing")} {indexOfFirstRow + 1} {t("to")} {Math.min(indexOfLastRow, invoice.length)}</span>
                            <Form.Select value={rowsPerPage} onChange={handleRowsPerPageChange} style={{ width: '150px' }}>
                                {[10, 25, 50, 100].map(value => <option key={value} value={value}>{value}</option>)}
                            </Form.Select>
                        </div>
                    </div>
                    <Table bordered hover>
                        <thead>
                            <tr>
                                <th>{t("Invoice number")}</th><th>{t("Payment date")}</th><th>{t("Total Amount")}</th><th>{t("Status")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentRows.map((muc, index) => (
                                <tr key={index}>
                                    <td onClick={() => handleViewDetailsCSHP(muc.id)} style={{ color: "#0069ff", cursor: "pointer" }}>#{muc?.invoice_number}</td>
                                    <td>{new Date(muc.created_at).toLocaleDateString('vi-VN')}</td>
                                    <td>{new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(muc?.total_amount)}</td>
                                    <td>
                                        <span
                                            style={{
                                                cursor: muc.status === 0 ? "pointer" : "default",
                                                backgroundColor: statusColors[muc.status] || "#6C757D",
                                                color: "#fff",
                                                padding: "3px 10px",
                                                borderRadius: "10px",
                                                display: "inline-block",
                                                fontSize: "12px",
                                                fontWeight: "bold"
                                            }}
                                        >
                                            {statusLabels[muc.status] || "Không xác định"}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <Pagination className="justify-content-center">
                        {[...Array(totalPages)].map((_, i) => (
                            <Pagination.Item key={i} active={i + 1 === currentPage} onClick={() => handlePageChange(i + 1)}>
                                {i + 1}
                            </Pagination.Item>
                        ))}
                    </Pagination>
                </Tab>

            </Tabs>
        </div>
    );
};

export default Invoice;
